import type { UAPStyleMap } from '../../@types';

export const getMmaPlacementBaseStyles = (_theme?: object): UAPStyleMap => ({
  placementCard: {
    border: 'solid thin #ddd',
  },

  placementImageContainer: undefined, // { },
  placementTextContainer: {
    position: 'absolute',
    left: 0,
    bottom: 25,
    paddingLeft: 32,
    paddingRight: 20,
    fontSize: 10,
    lineHeight: 1.1,
  },

  placementAdsLabel: undefined, // { },
  placementGradient: {
    backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
  },
  placementShortHeadline: {
    position: 'relative',
    bottom: 20,
    paddingBottom: 5,
    fontWeight: '200',
    fontSize: 24,
    color: 'white',
  },
  placementLongHeadline: {
    position: 'relative',
    bottom: 15,
    paddingBottom: 5,
    fontWeight: '200',
    fontSize: 24,
    color: 'white',
  },
  placementFinalUrl: {
    color: 'white',
    bottom: 10,
    position: 'relative',
    fontSize: 10,
  },
  placementDescription: {
    color: 'white',
    bottom: 5,
    position: 'relative',
    fontSize: 14,
  },
  placementCallToAction: {
    position: 'relative',
    borderRadius: 32,
    border: 'none',
    padding: '7px 16px 8px 16px',
    fontSize: 16,
    color: '#666',
    backgroundColor: '#EEE',
    opacity: '70%',
    fontWeight: 'bold',
  },
});


export const getMmaWideImage4x1Styles = (theme: object) => ({
  // base styles

  ...getMmaPlacementBaseStyles(theme),

  // overrides
  placementTextContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 25,
    paddingLeft: 32,
    fontSize: 10,
    lineHeight: '16px',
  },

  placementShortHeadline: {
    position: 'relative',
    bottom: 15,
    paddingBottom: 5,
    fontWeight: '200',
    fontSize: 24,
    color: 'white',
  },

  placementAdsLabel: {
    right: 0, // align to right
  },

  placementGradient: {
    backgroundImage: 'linear-gradient(to left, transparent 0, black 100%)',
  },
});


export const getMmaLandScapeImage191x100Styles = (theme: object) => ({
  // base styles

  ...getMmaPlacementBaseStyles(theme),

  // overrides
  placementTextContainer: {
    padding: '8px 20px 20px 20px',
    fontSize: 10,
    lineHeight: 1.1,
    maxWidth: '-webkit-fill-available',

    '& .logo-and-text-container': {
      display: 'flex',
      flexDirection: 'row',
      paddingBottom: 4,
      '& .logo-text': {
        display: 'flex',
        flexDirection: 'column',
        '& .logo-business-name': {
          color: '#111',
          fontSize: 14,
          fontWeight: 400,
          lineHeight: '18px',
        },
      },
    },
  },

  placementShortHeadline: {
    position: 'relative',
    color: 'black',
    fontSize: 24,
    marginBottom: 8,
    fontWeight: '200',
    paddingBottom: 5,
  },

  placementFinalUrl: {
    position: 'relative',
    color: 'green',
    fontSize: 10,
    marginBottom: 8,
  },

  placementDescription: {
    position: 'relative',
    color: 'black',
    fontSize: 14,
    maxWidth: 250,
    wordWrap: 'break-word',
    paddingRight: 16,
  },

  placementCallToAction: {
    color: 'white',
    right: 15,
    border: 'none',
    bottom: 15,
    opacity: '90%',
    padding: '6px 16px 8px 16px',
    position: 'absolute',
    fontSize: 16,
    fontWeight: 'bold',
    borderRadius: 32,
    backgroundColor: '#a19f9d',
  },

  placementLogoContainer: {
    paddingTop: 5,
    paddingRight: 6,
    '& .cropped-image-view': {
      borderRadius: 6,
      border: 'solid 1px #ECECEC',
    },
  },
});


export const getMmaSquareImage1x1Styles = (theme: object) => ({
  // base styles

  ...getMmaPlacementBaseStyles(theme),

  // overrides
  placementFinalUrl: {
    color: 'green',
    bottom: 18,
    position: 'relative',
    fontSize: 10,
  },

  placementDescription: {
    color: 'white',
    bottom: 8,
    position: 'relative',
    fontSize: 14,
  },

  placementCallToAction: {
    position: 'relative',
    borderRadius: 32,
    border: 'none',
    padding: '6px 16px 8px 16px',
    fontSize: 16,
    color: 'white',
    backgroundColor: '#a19f9d',
    opacity: '90%',
    fontWeight: 'bold',
  },
});


export const getMmaVerticalImage1x2Styles = (theme: object) => ({
  // base styles

  ...getMmaPlacementBaseStyles(theme),

  // overrides
  placementFinalUrl: {
    color: 'green',
    bottom: 15,
    position: 'relative',
    fontSize: 10,
  },

  placementCallToAction: {
    position: 'relative',
    top: 5,
    color: 'white',
    border: 'solid 1px #dddddd',
    opacity: '90%',
    padding: '5px 16px 6px 16px',
    fontSize: 14,
    fontWeight: 'bold',
    borderRadius: 3,
    backgroundColor: '#a19f9d',
  },
});
